import { render, staticRenderFns } from "./DBSeller.vue?vue&type=template&id=159d1a2f&"
import script from "./DBSeller.vue?vue&type=script&lang=js&"
export * from "./DBSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports